import React from 'react';
import { Chip } from '@mui/material';
import { ALL_GROUPS } from '../../types';
import { useFilter } from '../../FilterContext';

const ChannelGroupChips: React.FC = () => {
    const { channelGroupsWithChannels, selectedGroupId, setSelectedGroupId } =
        useFilter();

    return (
        <>
            <Chip
                label="All"
                color={selectedGroupId === ALL_GROUPS ? 'primary' : 'default'}
                variant={selectedGroupId === ALL_GROUPS ? 'solid' : 'outlined'}
                onClick={() => setSelectedGroupId(ALL_GROUPS)}
            />
            {channelGroupsWithChannels.map((group) => (
                <Chip
                    key={group._id}
                    label={group.name}
                    color={
                        selectedGroupId === group._id ? 'primary' : 'default'
                    }
                    variant={
                        selectedGroupId === group._id ? 'solid' : 'outlined'
                    }
                    onClick={() => setSelectedGroupId(group._id)}
                />
            ))}
        </>
    );
};

export default ChannelGroupChips;
